export default function getLocalization(stringKey) {
  if (typeof window.webfu_theme_screenReaderText === 'undefined' || typeof window.webfu_theme_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.webfu_theme_screenReaderText[stringKey];
}
